import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { ContentSearchPickerContentCard } from '~/components/ContentSearchPickerContentCard';
import { ISearchContentResult } from '~/searchApi';

import { CONTENT_SEARCH_MAX_HEIGHT } from './ContentSearchPickerSelected.constants';

export interface IContentSearchPickerSelectedProps
  extends Omit<FlexProps, 'onClick'> {
  onClick: (content: ISearchContentResult) => void;
  selectedContent: ISearchContentResult[];
}

export const ContentSearchPickerSelected: React.FC<
  IContentSearchPickerSelectedProps
> = ({ onClick, selectedContent, ...flexProps }) => {
  if (selectedContent.length) {
    return (
      <Flex
        flexWrap="wrap"
        gap={2}
        sx={{
          ':after': {
            content: '""',
            flexGrow: 999,
          },
        }}
        {...flexProps}
      >
        {selectedContent.map((content) => (
          <ContentSearchPickerContentCard
            key={content.contentId}
            contentData={content}
            onClick={() => onClick(content)}
            maxHeight={CONTENT_SEARCH_MAX_HEIGHT}
            isSelected
          />
        ))}
      </Flex>
    );
  }

  return (
    <Flex
      flexWrap="wrap"
      flexDirection="column"
      alignItems="center"
      paddingY={6}
    >
      <Text color="primary.400" fontSize="2xl" fontWeight={500}>
        You do not have any content selected
      </Text>
      <Text color="primary.300" fontSize="md">
        Add content from this creator below
      </Text>
    </Flex>
  );
};
